import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';



export const ConfirmationModal = ({isThisCenterAligned=false, buttonAction, open, handleClose, handleSubmitConfirmation }) => {
    const style = {
        position: 'absolute',
        top: '50%',
        left: isThisCenterAligned ? '50%': '68%',
        transform: 'translate(-50%, -50%)',
        width: 350,
        bgcolor: 'background.paper',
        border: 'none',
        boxShadow: 24,
        pt: 2,
        paddingLeft: 0,
        paddingRight: 0,
    };
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
        >
            <Box sx={{ ...style, width: 350 }}>
                <div>
                    <div className="alertMessage">
                        <h4>{buttonAction.event}</h4>
                        <p>{buttonAction.eventMessage}</p>
                    </div>
                    <div className='confirmationModalbuttonContainer'>
                        <button className='confirmationButtons confirmationCancel' onClick={handleClose}> Cancel</button>
                        <button className='confirmationButtons confirmationYes' onClick={handleSubmitConfirmation}> Yes {buttonAction.event}</button>
                    </div>
                </div>
            </Box>
        </Modal>
    );
}